import React, { useState } from 'react'
import { BaseDialog } from 'shared'

import { Stepper } from 'shared'
import EmailSentStep from './EmailSentStep'
import ChangePasswordStep from './ChangePasswordStep'
import ForgotPasswordStep from './ForgotPasswordStep'

import { BaseModalComponentType } from '../types'
import { withModal } from 'utils/providers/ModalProvider'
import modals from 'constants/modals'

const ChangePasswordModal = ({
  closeModal,
  isOpen,
}: BaseModalComponentType) => {
  const [title, setTitle] = useState('Change password')

  return (
    <BaseDialog open={isOpen} onClose={closeModal} title={title}>
      <Stepper>
        <ChangePasswordStep
          closeModal={closeModal}
          onMount={() => setTitle('Change password')}
        />
        <ForgotPasswordStep onMount={() => setTitle('Change password')} />
        <EmailSentStep onMount={() => setTitle('Email sent')} />
      </Stepper>
    </BaseDialog>
  )
}

export default withModal(modals.changePasswordModal)(ChangePasswordModal)
